import { render } from "./PostsPassportHistory.vue?vue&type=template&id=416aef20&scoped=true"
import script from "./PostsPassportHistory.vue?vue&type=script&lang=js"
export * from "./PostsPassportHistory.vue?vue&type=script&lang=js"

import "@/assets/table.css?vue&type=style&index=0&id=416aef20&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416aef20"]])

export default __exports__